import httpClient from './httpClient';

const supplierService = {
  /**
   * Get list of suppliers with optional filtering
   * @param {Object} params - Query parameters
   * @param {string} params.supplier_name - Filter by supplier name
   * @param {number} params.page - Page number (default 1)
   * @param {number} params.page_size - Items per page (default 100)
   */
  async getSuppliers(params = {}) {
    try {
      const response = await httpClient.get('/api/suppliers', {
        params: {
          page: 1,
          page_size: 100,
          ...params
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching suppliers:', error);
      throw error;
    }
  },

  /**
   * Search suppliers by name
   * @param {string} name - Search term
   */
  async searchSuppliers(name) {
    try {
      const response = await httpClient.get('/api/suppliers', {
        params: {
          supplier_name: name,
          page: 1,
          page_size: 50
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error searching suppliers:', error);
      throw error;
    }
  },

  /**
   * Get single supplier by ID
   * @param {string} supplierId - Supplier ID
   */
  async getSupplier(supplierId) {
    try {
      const response = await httpClient.get(`/api/suppliers/${supplierId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching supplier:', error);
      throw error;
    }
  }
};

export default supplierService;
